export const BarColors = [
    "linear-gradient(0deg, #FAE391, #FAE391), linear-gradient(90deg, #FFC545 0%, #FFCE62 100%)",
    "linear-gradient(0deg, #FFD069, #FFD069), linear-gradient(55.76deg, #F1525F 3.94%, #FF818B 91%), #FFC545",
    "linear-gradient(0deg, #F09765, #F09765), linear-gradient(269.78deg, #6FCC87 0.13%, #54B06C 100.09%), linear-gradient(55.76deg, #F1525F 3.94%, #FF818B 91%), #FFC545 ",
    "#8DD29F",
    "#F6737D",
    "#8BB1FA",
];
